"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementManageState_1 = require("@/room/settlement_manage/settlementManageState");
const react_i18next_1 = require("react-i18next");
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const RadioGroup_1 = __importDefault(require("@mui/material/RadioGroup"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
function default_1({ expand }) {
    const [settlementRewardSelect, setSettlementRewardSelect] = (0, recoil_1.useRecoilState)(settlementManageState_1.settlementRewardSelectState);
    const { total_withdrawable_amount, total_reward_amount } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementTotalAmountState);
    const { room_status_cd } = (0, recoil_1.useRecoilValue)(settlementManageState_1.settlementDetailsDataState);
    const isRewardSelectable = !total_withdrawable_amount && !!total_reward_amount && room_status_cd === 'ROOM_STATUS_06';
    const RewardSelectFCL = ({ value, label }) => ((0, jsx_runtime_1.jsx)(FormControlLabel_1.default, { disabled: !isRewardSelectable, value: value, control: (0, jsx_runtime_1.jsx)(Radio_1.default, { color: "secondary" }), label: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body2" }, { children: label })), sx: {
            ml: '-4px',
            '.MuiFormControlLabel-label': {
                ml: '4px',
                color: 'var(--gray-30)',
            },
            '.Mui-checked + .MuiFormControlLabel-label': {
                color: 'var(--gray-80)',
            },
            '.Mui-disabled + .MuiFormControlLabel-label': {
                color: 'var(--gray-30)',
            },
        } }));
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: expand, timeout: 150 }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', flexDirection: 'column', rowGap: '10px', paddingTop: '10px' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "body2 gray-80 surface-bg", css: { padding: '12px 14px', borderRadius: '8px' } }, { children: [t('폰디가 드리는 작가지원금이에요.'), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: [t('[배송/교환/정산이 완료되고]'), "\u00A0"] })), t('구매자 정보 폐기 눌러주세요.')] })), (0, jsx_runtime_1.jsxs)(RadioGroup_1.default, Object.assign({ value: settlementRewardSelect, onChange: e => setSettlementRewardSelect(e.target.value), sx: {
                        rowGap: '11px',
                        p: '4px 0',
                    } }, { children: [(0, jsx_runtime_1.jsx)(RewardSelectFCL, { value: "keep", label: t('내가 받기') }), (0, jsx_runtime_1.jsx)(RewardSelectFCL, { value: "share", label: t('구매자 나눔') })] }))] })) })));
}
exports.default = default_1;
